interface NotificationFilterTabsProps {
  filter: 'all' | 'unread' | 'read';
  onFilterChange: (filter: 'all' | 'unread' | 'read') => void;
  allCount: number;
  unreadCount: number;
  readCount: number;
}

export default function NotificationFilterTabs({
  filter,
  onFilterChange,
  allCount,
  unreadCount,
  readCount
}: NotificationFilterTabsProps) {
  const tabs = [
    { key: 'all' as const, label: 'All', count: allCount },
    { key: 'unread' as const, label: 'Unread', count: unreadCount },
    { key: 'read' as const, label: 'Read', count: readCount }
  ];

  return (
    <div className="px-4 pb-4">
      <div className="flex space-x-1 rounded-lg bg-gray-100 p-1">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onFilterChange(tab.key)}
            className={`flex-1 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
              filter === tab.key
                ? 'bg-white text-orange-600 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {tab.label} ({tab.count})
          </button>
        ))}
      </div>
    </div>
  );
}
